import { SxProps } from '@mui/material'
import { popperDimensions } from './Popper.data'

interface PopperStyles {
  wrapper: SxProps
  contentWrapper: SxProps
}

export const popperStyles: PopperStyles = {
  wrapper: { zIndex: 10 },
  contentWrapper: {
    borderRadius: 2,
    backgroundColor: 'background.default',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.secondary',
    p: popperDimensions.padding,
    boxShadow:
      '0px 12px 16px -4px rgba(10, 13, 18, 0.08), 0px 4px 6px -2px rgba(10, 13, 18, 0.03), 0px 2px 2px -1px rgba(10, 13, 18, 0.04) ',
  },
}
